import moment, {Moment} from "moment";
import { OpeningHoursScheduleInterface } from "../exports/Interfaces";

class PickUpTimesResource {
  public createDate(times: OpeningHoursScheduleInterface, time?: Moment|string|null) {
    const date = moment(time ?? undefined).set({
      day: times?.day,
      hour: times?.hour,
      minute: times?.minute,
      second: 0,
      millisecond: 0
    });

    if (! moment(time ?? undefined).isSame(date, 'week')) {
      return date.add(1, 'week');
    }

    return date;
  }
}

export default new PickUpTimesResource();
